import {
  type CartLineItem,
  isAdProductLineItem,
  isAdProductUpgradeLineItem,
} from 'src/app/state/types/cart';
import {
  type OrderRequestInputItem,
  type ProductSet,
  ProductTypeInput,
} from 'src/graphql/generated';

const mapCartLineItemToOrderLineItem = (
  cartLineItem: CartLineItem,
): OrderRequestInputItem => {
  const isAdProductRelatedItem =
    isAdProductLineItem(cartLineItem) ||
    isAdProductUpgradeLineItem(cartLineItem);
  const jobId = isAdProductRelatedItem && cartLineItem.jobId;
  const revisionId = isAdProductRelatedItem && cartLineItem.revisionId;

  return {
    productType: ProductTypeInput.CATALOGUE_PRODUCT,
    productAttributes: {
      catalogueProduct: {
        ...(jobId && {
          jobId,
        }),
        ...(revisionId && {
          revisionId,
        }),
        productId: cartLineItem.productId,
        productSetId: cartLineItem.productSetId,
      },
    },
  };
};

const mapCartLineItemsWithNewProductSetId = (
  lineItems: CartLineItem[],
  productSet: ProductSet,
) =>
  lineItems.map((lineItem) => {
    if (!productSet.items.find((item) => item?.id === lineItem.productId)) {
      throw new Error('Product id unavailable in product');
    }
    return {
      ...lineItem,
      productSetId: productSet.id,
    };
  });

export { mapCartLineItemToOrderLineItem, mapCartLineItemsWithNewProductSetId };
